<template>
  <div
    class="h-16 min-h-14 w-full bg-blue-800 text-white px-4 py-4 flex items-center"
  >
    <div class="mr-4" @click="sidebarToggle" v-if="canShowMenu">
      <img src="/icons/menu.svg" alt="Icon" class="h-4" />
    </div>
    <div class="flex items-center">
      <img
        src="data:image/png;base64,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"
        alt="logo"
        class="h-8 mr-4"
      />
      <div class="py-1 font-bold">Measurement Portal</div>
    </div>

    <!--    <div class="py-1 flex flex-row" v-if="getAuthLoggedIn">-->
    <!--      <div class="px-6">Logged in as: {{ getAuth.userEmail }}</div>-->
    <!--      <div @click="logout">Log out</div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ROUTE_LOGIN } from "@/router";

export default {
  name: "TopBar",
  components: {},
  computed: {
    ...mapGetters({
      getAuthLoggedIn: "auth/getAuthLoggedIn",
      getAuth: "auth/getAuth",
      getCurrentRoute: "application/getCurrentRoute",
      canShowMenu: "application/canShowMenu"
    }),
    ...mapActions(["auth/authCheck", "layout/toggleSidebar"])
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    sidebarToggle() {
      if (!this.getAuthLoggedIn || !this.canShowMenu) return;
      this.$store.dispatch("layout/toggleSidebar");
    },
    logout() {
      this.$store.dispatch("auth/authLogout").then(() => {
        this.$router.replace({ name: ROUTE_LOGIN });
      });
    }
  }
};
</script>
